import { render, staticRenderFns } from "./VisualizarColecao.vue?vue&type=template&id=63e7ac97&scoped=true&"
import script from "./VisualizarColecao.vue?vue&type=script&lang=js&"
export * from "./VisualizarColecao.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarColecao.vue?vue&type=style&index=0&id=63e7ac97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e7ac97",
  null
  
)

export default component.exports